import React from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './ComingSoon.css'

const ComingSoon = () => (
  <div className={styles.coming_soon}>
    <FormattedMessage id="general.coming_soon" />
  </div>
)

export default ComingSoon
